export default "__VITE_ASSET__Xa_4RyCp__"